export default function addStatFilters(self, fields) {
  const statKeys = [
    "Like",
    "Dislike",
    "Upvote",
    "Downvote",
    "Subscribe",
    "Unsubscribe",
  ].map(function (str) {
    return {
      title: `${str}s`,
      key: `_${str.toLowerCase()}`,
    };
  });

  const StatFields = {
    title: `Reactions`,
    minimum: 1,
    maximum: 1,
    key: `meta.stats`,
    asObject: true,
    type: "group",
    fields: [],
  };

  statKeys.forEach(function ({ title, key }) {
    StatFields.fields.push({
      title: `All ${title}`,
      minimum: 1,
      maximum: 1,
      key,
      type: "integer",
    });
  });

  fields.push(StatFields);

  // Your Unique Stats
  const YourStatFields = {
    title: `Reactions`,
    minimum: 1,
    maximum: 1,
    key: `_stat`,
    asObject: true,
    type: "group",
    fields: [],
  };

  statKeys.forEach(function ({ title, key }) {
    YourStatFields.fields.push({
      title: `Your ${title}`,
      minimum: 1,
      maximum: 1,
      key,
      type: "integer",
    });
  });

  fields.push(YourStatFields);
}
